/**
 * MEDICLOUD REST API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { InvoiceItemApiModel } from './invoiceItemApiModel';


export interface InvoiceCreateApiModel { 
    tenantId: number;
    items: Array<InvoiceItemApiModel>;
    issueDate: string;
    deliveryDate: string;
}

